<template>
  <div class="detail_apply_bottom">
    <div class="left_box">
      <div class="nav">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="详情介绍" name="second">
            <div class="xiangqing">
              <div v-html="mydesc" v-if="mydesc != ''"></div>
              <!-- 空状态 -->
              <div v-else style="width: 100%">
                <div
                  style="
                    margin: auto;
                    width: 18rem;
                    height: 18rem;
                    text-align: center;
                  "
                >
                  <img
                    style="width: 90%; height: 90%"
                    src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                    alt=""
                  />
                  <div style="color: #333333">暂时没有数据</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="活动目录" name="third">
            <!-- 购前必读部分，后端接口待完善先隐藏 -->
            <div
              class="dayLook_box tips_box"
              v-if="allMyitem.lesson_before != null"
            >
              <div class="muluTitle">
                <div class="muluTitle_text">打卡学员购前必读（本节免费）</div>
                <div class="section_down" @click="down('tips')">
                  <span>{{ tipsFlag == false ? "展开" : "收起" }}</span>
                  <i
                    class="iconfont icon-jiantoudown"
                    :class="[tipsFlag == false ? 'icoDwon' : 'icoUp']"
                  ></i>
                </div>
              </div>
              <div class="tipsContentBox" v-show="tipsFlag">
                <div>
                  <tips
                    v-for="(item, index) in allMyitem.lesson_before"
                    :key="index"
                    :obj="item"
                    :MYnumber="index + 1"
                    :camp="mycamp_id"
                  ></tips>
                </div>
              </div>
            </div>
            <div class="dayLook_box">
              <div class="muluTitle">
                <div class="muluTitle_text">打卡任务</div>
                <div class="section_down" @click="down('mulu')">
                  <span>{{ muluFlag == false ? "展开" : "收起" }}</span>
                  <i
                    class="iconfont icon-jiantoudown"
                    :class="[muluFlag == false ? 'icoDwon' : 'icoUp']"
                  ></i>
                </div>
              </div>
              <div class="muluBox" v-show="muluFlag" v-if="empty1">
                <!-- 上次学到部分 -->
                <div class="last_box" v-if="allMyitem.last_learn != null">
                  上次学到：
                  <span class="colorOrange">
                    <!-- 作业打卡显示第几课 天数打卡显示第几天 -->
                    <span v-if="allMyitem.detail.sign_type == '作业打卡'"
                      >第 {{ allMyitem.last_learn.day }} 课
                    </span>
                    <span v-else>DAY {{ allMyitem.last_learn.day }}</span>
                    {{ allMyitem.last_learn.lesson_name }}
                  </span>
                </div>
                <DayLook
                  v-for="(item, index) in myitem"
                  :key="index"
                  :day="item.day"
                  :myitem="item"
                  :is_login="is_login"
                  :is_apply="is_apply"
                  :status="status"
                ></DayLook>
              </div>
              <!-- 空状态 -->
              <div v-else style="width: 100%" v-show="muluFlag">
                <div
                  style="
                    margin: auto;
                    width: 18rem;
                    height: 18rem;
                    text-align: center;
                  "
                >
                  <img
                    style="width: 90%; height: 90%"
                    src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                    alt=""
                  />
                  <div style="color: #333333">暂时没有数据</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="打卡日记" name="fourth">
            <div class="shart_box">
              <div class="shart_btn_box" v-if="!is_apply">
                <div class="shart_btn">
                  <button>报名后即可写日记</button>
                </div>
              </div>
              <div class="share_comment" v-if="empty2">
                <shareCard
                  v-for="item in comment.list"
                  :key="item.share_id"
                  :myitem="item"
                ></shareCard>
              </div>
              <router-link :to="shareMore" v-if="empty2">
                <div class="more" v-if="empty2 || comment.list.count > 3">
                  查看更多打卡日记<i class="iconfont icon-jiantou"></i></div
              ></router-link>
              <!-- 空状态 -->
              <div v-else style="width: 100%">
                <div
                  style="
                    margin: auto;
                    width: 18rem;
                    height: 18rem;
                    text-align: center;
                  "
                >
                  <img
                    style="width: 90%; height: 90%"
                    src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                    alt=""
                  />
                  <div style="color: #333333">暂时没有数据</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资料下载" name="ziliao" v-if="mydata != null">
            <div
              class="data_box"
              v-for="item in mydata"
              :key="item.file_id"
              @click="download(item.file_id, item.name)"
            >
              <div class="data">
                <div class="data_left">
                  <div class="ico_tuwen">
                    <i class="iconfont icon-xuexiziliao"></i>
                  </div>
                  <div class="data_name">{{ item.name }}</div>
                </div>
                <div class="data_right">
                  <div
                    class="btn"
                    :class="[allMyitem.is_apply ? '' : 'noApply']"
                  >
                    下载
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- 网课赠送 -->
          <el-tab-pane
            label="赠课列表"
            name="giveClass"
            v-if="giveClassList != null && giveClassList.length != 0"
          >
            <div class="giveClass_box">
              <div v-for="(item, index) in giveClassList" :key="item.id">
                <giveClass
                  @freeUpdate="getGiveClass()"
                  :isApply="is_apply"
                  :item="item"
                  :num="index + 1"
                ></giveClass>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right_box">
      <div class="E_allItem_right_title">
        <img
          src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/tuijian.png"
          alt=""
        />
      </div>
      <div class="hotSwiper_parent">
        <hotSwiper></hotSwiper>
      </div>
    </div>
    <!-- 右侧悬浮栏 -->
    <rightNav></rightNav>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DayLook from "@/components/detail_child/DayLook.vue";
import shareCard from "@/components/shareCard.vue";
import tips from "@/components/detail_child/tips.vue";
// import download from "downloadjs"; // 引用下载插件
import giveClass from "@/components/detail_child/giveClass.vue";
// 右侧热门推荐部分轮播图内容
import hotSwiper from "@/components/common/HotSwiper.vue";
// 右侧悬浮导航条
import rightNav from "@/components/common/rightNav.vue"
export default {
  components: {
    // applyTable,
    DayLook,
    shareCard,
    tips,
    giveClass,
    hotSwiper,
    rightNav
  },
  name: "detail_bottom",
  props: {
    // 用户是否报名课程
    is_apply: {
      type: Boolean,
      defulat: false,
    },
    // 活动目录传值
    myitem: {
      type: Array,
      default: () => [],
    },
    // // 训练营详情传值（富文本）
    mydesc: {
      type: String,
      default: "",
    },
    // 当前教师
    myTeacher: {
      type: Object,
      default: () => {
        return {
          id: 234,
          uuid: "",
          name: "",
          title: "",
          status: "",
          desc: "",
          org_id: 0,
          is_live: 0,
          username: null,
          rating: null,
          create_time: "",
          update_time: "",
          delete_time: 0,
          old_id: 0,
          old_exams: "",
          is_backstage: 0,
          subject_list: [""],
          avatar: "",
        };
      },
    },
    // 客服
    mykefu: {
      type: Object,
      default: () => {
        return {
          mobile: "15201033560",
          name: "",
          qq_qrcode: "",
          weixin_qrcode: "",
        };
      },
    },
    // 用户登录状态
    is_login: {},
    // detail信息
    status: {},
    // 全部detall信息
    allMyitem: {},
  },
  data() {
    return {
      // 当前活动的列表框
      activeName: "second", //third
      // 当前训练营下的评论列表
      comment: [],
      // 空状态
      empty1: true,
      empty2: true,
      // 当前的训练营ID
      mycamp_id: "",
      // 资料下载列表
      mydata: null,
      // 目录是否展开
      muluFlag: true,
      // 购前必读
      tipsFlag: true,
      // 赠送课程列表
      giveClassList: null,
    };
  },
  methods: {
    ...mapMutations(["fileStatus", "giveClass"]),
    handleClick(tab, event) {
      return tab, event;
    },
    // 请求评论列表
    getShareList() {
      this.$axios
        .get("/getShareList", {
          params: {
            // token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
            sort: 2,
          },
        })
        .then((doc) => {
          this.comment = doc;
          if (this.comment.list == null) {
            this.empty2 = false;
          } else {
            this.empty2 = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求下载资料列表
    getCampFiles() {
      var token = null;
      if (localStorage.getItem("token") != null) {
        token = localStorage.getItem("token");
      }
      this.$axios
        .get("/getCampFiles", {
          params: {
            token: token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          console.log(doc);
          this.mydata = doc.files;
          // 组件通信将当前下载列表进行传输
          this.fileStatus(doc);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下载资料
    download(filesId, filesName) {
      console.log(this.allMyitem.is_apply);
      if (this.allMyitem.is_apply != true) {
        this.$alert("请报名之后再下载", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$axios
        .get("/campFileDownload", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            file_id: filesId,
          },
        })
        .then((doc) => {
          // window.location.href = doc.url
          let houzui = doc.url.split(".");
          houzui = houzui[houzui.length - 1];
          this.downloadFile(doc.url, filesName + "." + houzui);
          // download(doc.url, filesName + "." + houzui);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadFile(url, fileName) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = function () {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    // 活动目录的展开与收起动作
    down(item) {
      if (item == "mulu") {
        this.muluFlag = !this.muluFlag;
      } else if (item == "tips") {
        this.tipsFlag = !this.tipsFlag;
      }
    },
    // 请求赠送课程内容
    // 请求下载资料列表
    getGiveClass() {
      this.$axios
        .get("/getCampFree", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.giveClassList = doc.free;
          // 组件通信将当前下载列表进行传输
          this.giveClass(doc);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.mycamp_id = this.$route.params.id;
    this.getShareList();
    // if (localStorage.getItem("token") != null) {
    this.getCampFiles();
    // }
    this.getGiveClass();
  },
  computed: {
    ...mapState(["fileList"]),
    agency_id() {
      if (localStorage.getItem("agency_id")) {
        return localStorage.getItem("agency_id");
      } else {
        return 281;
      }
    },
    token() {
      if (localStorage.getItem("token")) {
        return localStorage.getItem("token");
      } else {
        return null;
      }
    },
    shareMore() {
      return "/Detail/Introduce/" + this.mycamp_id;
    },
  },
  watch: {
    myitem(val) {
      if (val.length == 0) {
        this.empty1 = false;
      } else {
        this.empty1 = true;
      }
    },
  },
};
</script> 

<style lang="less" scoped>
.detail_apply_bottom {
  margin-top: 1.875rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: auto;
  // 下方左侧选项卡部分盒子
  .left_box {
    flex: 1;
    // width: 51.25rem;
    // height: 63.75rem;
    background: #ffffff;
    box-shadow: 0px 0.125rem 0.375rem 0px rgba(212, 214, 216, 0.3);
    // 选项卡部分
    .nav {
      width: 100%;
      /deep/ .el-tabs {
        .el-tabs__nav {
          padding-left: 2.625rem;
          .el-tabs__item {
            height: 3.5625rem;
            line-height: 3.5625rem;
            font-size: 1rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #afafaf;
          }
          // 当前活动字体颜色
          .is-active {
            color: #4e4e4e;
          }
          // 活动下标条
          .el-tabs__active-bar {
            margin-left: 2.625rem;
            background-color: #364348;
            height: 0.1875rem;
          }
          // 活动选项卡内容部分
        }
        .el-tabs__nav-wrap::after {
          height: 0.0625rem;
          background: #f0f1f1;
        }
      }
      // 详情介绍部分
      .xiangqing {
        padding: 1.1875rem;
        padding-top: 0;
        width: 100%;
        height: auto;
        div {
          width: 100%;
          height: auto;
          /deep/ img {
            max-width: 100%;
            display: block;
            margin: 0 auto;
          }
        }
      }
      // 活动目录部分
      .dayLook_box {
        padding: 0 1.25rem 1.8125rem 1.25rem;
        .last_box {
          margin: 0.75rem 0 1.0625rem 0;
          font-size: 0.75rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #9e9e9e;
        }

        // 目录标题
        .muluTitle {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-content: center;
          margin-bottom: 1.375rem;
          .muluTitle_text {
            font-size: 1.125rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
          }
          .section_down {
            cursor: pointer;
            margin-right: 0.625rem;
            text-align: center;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            font-size: 1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #686868;
            span {
              margin-right: 0.5rem;
            }
            .icoUp {
              transform: rotate(180deg);
            }
          }
        }
      }

      // 购前必读部分
      .tips_box {
        padding: 0.5rem 1.25rem 0rem 1.25rem;
        margin-bottom: 1rem;
        border-bottom: 0.0625rem solid #f0f1f1;
        .tipsContentBox {
          margin-bottom: 1.875rem;
          background: #f8f8f8;
        }
      }

      // 学员分享部分
      .shart_box {
        width: 100%;
        height: auto;
        .shart_btn_box {
          padding: 0 1.875rem;
          width: 100%;
          height: auto;
          border-bottom: 0.0625rem solid #f0f1f1;
          // 分享部分的按钮
          .shart_btn {
            margin: auto;
            margin-bottom: 1.125rem;
            width: 100%;
            height: 3.375rem;
            text-align: center;
            line-height: 3.375rem;
            background: #f5f7fa;

            button {
              border: none;
              background: transparent;
              font-size: 1rem;
              font-family: " Microsoft YaHei";
              font-weight: 400;
              color: #686868;
              border-radius: 0.125rem;
            }
          }
        }
        //分享内容部分
        .share_comment {
          width: 100%;
          height: auto;
          /deep/ .sharCard {
            margin-top: 0;
            width: 100%;
            border-left: none;
            border-right: none;
            border-top: none;
          }
        }
        // 查看更多
        .more {
          width: 100%;
          height: 4.4375rem;
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #424242;
          text-align: center;
          line-height: 4.4375rem;
          cursor: pointer;
          .icon-jiantou:before {
            margin-left: 0.3125rem;
            font-size: 0.375rem;
            font-weight: 400;
            color: #424242;
          }
        }
      }

      //网课赠送部分
      .giveClass_box {
        padding: 0 1.25rem 1.8125rem 1.25rem;
      }
    }
  }
  // 下方右侧讲师介绍部分盒子
  .right_box {
    margin-left: 31px;
    width: 324px;
    height: 515px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(212, 214, 216, 0.3);
    .E_allItem_right_title {
      padding: 0.9375rem;
    }
    .hotSwiper_parent{
      padding: 0 1.6875rem;
    }
  }
  // 资料下载栏
  .data_box {
    padding: 0 1.25rem 0.9125rem 1.25rem;
  }
  .data {
    // margin-bottom: 1.5625rem;
    padding: 0.3125rem 0 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 3.375rem;
    background: #f5f5f5;
    border-radius: 0.125rem;
    .data_left {
      padding: 0.3125rem 0;
      margin-left: 1.1875rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .ico_tuwen {
        width: 1.3125rem;
        height: 1.3125rem;
        border-radius: 50%;
        background-color: #ced5da;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .icon-xuexiziliao::before {
          color: #fff;
          font-size: 0.5625rem;
        }
      }
      .data_name {
        margin: 0 1.25rem 0 0.5rem;
        color: #686868;
        font-size: 1rem;
        // font-weight: Bold;
      }
    }
    .data_right {
      flex-shrink: 0;
      margin-right: 0.6875rem;
      width: 5.5rem;
      height: 1.9375rem;
      .btn {
        text-align: center;
        line-height: 1.9375rem;
        width: 100%;
        height: 100%;
        background-color: #ff7d3a;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
        border: 0.0625rem solid #e8e8e8;
        border-radius: 0.1875rem;
        cursor: pointer;
      }
      .noApply {
        background-color: #999;
      }
    }
  }
}
</style>